"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var sent_deploy_contract_tx_1 = require("./sent-deploy-contract-tx");

var tx_1 = require("./tx");

var TxDeploy = /*#__PURE__*/function (_tx_1$Tx) {
  _inherits(TxDeploy, _tx_1$Tx);

  function TxDeploy(eth, contractEntry, contractAbi, deployData) {
    var _this;

    var args = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var defaultOptions = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var onDeployed = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function (x) {
      return x;
    };

    _classCallCheck(this, TxDeploy);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TxDeploy).call(this, eth, contractEntry, contractAbi, undefined, args, defaultOptions));
    _this.deployData = deployData;
    _this.onDeployed = onDeployed;
    return _this;
  }

  _createClass(TxDeploy, [{
    key: "send",
    value: function send(options) {
      var sentTx = _get(_getPrototypeOf(TxDeploy.prototype), "send", this).call(this, options);

      return new sent_deploy_contract_tx_1.SentDeployContractTx(this.eth, this.contractAbi, sentTx.getTxHash(), this.onDeployed);
    }
  }, {
    key: "encodeABI",
    value: function encodeABI() {
      return Buffer.concat([this.deployData, this.contractEntry.encodeParameters(this.args)]);
    }
  }]);

  return TxDeploy;
}(tx_1.Tx);

exports.TxDeploy = TxDeploy;